import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ENotAvailableModalTypes, TOpenNotAvailableModalPayload } from './types';

export const openNotAvailableModal = actionGenerator<ENotAvailableModalTypes.Open, TOpenNotAvailableModalPayload>(
  ENotAvailableModalTypes.Open,
);
export const closeNotAvailableModal = actionGenerator<ENotAvailableModalTypes.Close>(ENotAvailableModalTypes.Close);
